import PolicyContractsContainer from './policy_contracts/PolicyContractsContainer';
export default PolicyContractsContainer;
